export function formatTotalValue(value) {
    return new Intl.NumberFormat("pt-BR", {
        style: "currency",
        currency: "BRL",
    }).format(value !== null && value !== void 0 ? value : 0);
}
